{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-9-informatik-datenbanken-sql",
  "version": "2026.08.1",
  "title": "Relationale Datenbanken und SQL (Realschule 9 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Informatik 9: Relationale Datenmodellierung, Tabellenbeziehungen, Primär- und Fremdschlüssel sowie SQL-Abfragen.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T21:45:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/9/informatik",
      "checked": "2026-08-15",
      "label": "Realschule Informatik 9 (I), Lernbereich Relationale Datenbanksysteme"
    }
  ],
  "atoms": [
    {
      "id": "01K4D9B0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4D9B0000000000000000A01",
      "namespace": "informatik-datenbanken",
      "slug": "relationales-modell-tabelle-primaerschluessel",
      "title": "Relationales Datenmodell: Tabelle, Datensatz und Primärschlüssel",
      "domain": "schule/informatik/datenbanken",
      "reduction": "axiomatic",
      "typical_age_min": 14.0,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q192588",
          "target_label": "Relational database",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "informatik",
          "topic_code": "lb1",
          "topic_title": "Relationale Datenbanksysteme",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D9B0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Eigenschaft muss ein Primärschlüssel (Primary Key) in einer relationalen Datenbanktabelle zwingend erfüllen?",
          "concept": "Er muss jeden Datensatz (Zeile) eindeutig und unverwechselbar identifizieren",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Jeden Datensatz der Tabelle eindeutig identifizieren",
              "In jedem Datensatz denselben Wert besitzen"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D9B0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die Grundbegriffe des relationalen Datenbankmodells: Tabelle/Relation, Datensatz/Tupel, Attribut/Feld und Primärschlüssel anhand eines Beispiels (z. B. Schülertabelle).",
          "concept": "Tabelle = Relation; Zeile = Datensatz (konkretes Objekt); Spalte = Attribut (Eigenschaft mit Datentyp); Primärschlüssel = eindeutiges Identifikationsattribut",
          "sample_solution": "Im relationalen Datenmodell: 1. Tabelle (Relation): Zweidimensionale Struktur zur Speicherung gleichartiger Informationsobjekte (z. B. Tabelle 'Schueler'). 2. Attribut (Spalte): Ein Merkmal bzw. eine Eigenschaft eines Objekts mit festem Datentyp (z. B. Nachname, Vorname, Geburtsdatum). 3. Datensatz (Zeile/Tupel): Eine konkrete Instanz aller Attribute (z. B. ein einzelner Schüler mit allen seinen Daten). 4. Primärschlüssel (PK): Ein minimales Attribut (oder Attributkombination), das jeden Datensatz eindeutig und eindeutig identifiziert (z. B. 'SchuelerID'), sodass keine Duplikate existieren dürfen."
        }
      ]
    },
    {
      "id": "01K4D9B0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4D9B0000000000000000A02",
      "namespace": "informatik-datenbanken",
      "slug": "tabellenbeziehungen-fremdschluessel-integritaet",
      "title": "Tabellenbeziehungen: 1:n, n:m, Fremdschlüssel und referenzielle Integrität",
      "domain": "schule/informatik/datenbanken",
      "reduction": "axiomatic",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4D9B0000000000000000A01",
          "type": "hard",
          "rationale": "Primärschlüssel sind Voraussetzung für Fremdschlüsselbeziehungen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q192588",
          "target_label": "Foreign key",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "informatik",
          "topic_code": "lb1",
          "topic_title": "Relationale Datenbanksysteme",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D9B0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie wird eine 1:n-Beziehung (z. B. Eine Klasse hat viele Schüler) in einer relationalen Datenbank technisch realisiert?",
          "concept": "Der Primärschlüssel der 1-Seite wird als Fremdschlüssel in die Tabelle der n-Seite eingefügt",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Der Primärschlüssel der 1-Seite wird als Fremdschlüssel in die n-Tabelle eingetragen",
              "Es wird immer eine zusätzliche Zwischentabelle benötigt"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D9B0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das Konzept des Fremdschlüssels (Foreign Key), definiere die referenzielle Integrität und beschreibe, wie eine n:m-Beziehung aufgelöst wird.",
          "concept": "Fremdschlüssel verweist auf Primärschlüssel anderer Tabelle; referenzielle Integrität verhindert ungültige Verweise; n:m wird über Zwischentabelle mit 2 1:n-Beziehungen aufgelöst",
          "sample_solution": "1. Fremdschlüssel (FK): Ein Attribut in einer Tabelle, das auf den Primärschlüssel einer anderen Tabelle verweist, um Datensätze miteinander zu verknüpfen. 2. Referenzielle Integrität: Eine Konsistenzregel, die garantiert, dass ein Fremdschlüsselwert immer auf einen tatsächlich existierenden Primärschlüsseleintrag der Elterntabelle verweisen muss (keine 'verwaisten' Datensätze beim Löschen/Ändern). 3. Auflösung einer n:m-Beziehung (z. B. Schüler belegen Kurse): Eine n:m-Beziehung kann relational nicht direkt abgebildet werden und wird durch eine Zwischentabelle (Verknüpfungstabelle) in zwei 1:n-Beziehungen aufgespalten, wobei die Zwischentabelle die Primärschlüssel beider Tabellen als Fremdschlüssel enthält."
        }
      ]
    },
    {
      "id": "01K4D9B0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4D9B0000000000000000A03",
      "namespace": "informatik-datenbanken",
      "slug": "sql-abfragen-select-from-where",
      "title": "SQL-Datenabfragen: SELECT, FROM, WHERE und ORDER BY",
      "domain": "schule/informatik/datenbanken",
      "reduction": "axiomatic",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4D9B0000000000000000A01",
          "type": "hard",
          "rationale": "Tabellen und Attribute sind Voraussetzung für SQL-Abfragen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q47607",
          "target_label": "SQL",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "informatik",
          "topic_code": "lb1",
          "topic_title": "Relationale Datenbanksysteme",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D9B0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche SQL-Klausel wird verwendet, um die Ergebniszeilen nach einer bestimmten Bedingung (z. B. Alter >= 14) zu filtern?",
          "concept": "WHERE",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "WHERE",
              "ORDER BY"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D9B0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die vier Grundklauseln einer SQL-Abfrage (SELECT, FROM, WHERE, ORDER BY) und schreibe eine SQL-Abfrage, die Vorname und Nachname aller Schüler aus der Klasse '9A' aufsteigend nach Nachname sortiert ausgibt.",
          "concept": "SELECT spalten FROM tabelle WHERE bedingung ORDER BY spalte ASC/DESC; SELECT Vorname, Nachname FROM Schueler WHERE Klasse = '9A' ORDER BY Nachname ASC;",
          "sample_solution": "Die Klauseln: 1. SELECT: Bestimmt die auszugebenden Spalten (Projektion). 2. FROM: Bestimmt die Quelltabelle(n). 3. WHERE: Filtert die Datensätze nach einer logischen Bedingung (Selektion mit AND, OR, NOT, =, <, >). 4. ORDER BY: Sortiert das Ergebnis aufsteigend (ASC, Standard) oder absteigend (DESC). Die geforderte SQL-Abfrage lautet: SELECT Vorname, Nachname FROM Schueler WHERE Klasse = '9A' ORDER BY Nachname ASC;"
        }
      ]
    },
    {
      "id": "01K4D9B0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4D9B0000000000000000A04",
      "namespace": "informatik-datenbanken",
      "slug": "sql-verbundabfragen-inner-join",
      "title": "SQL-Verbundabfragen über mehrere Tabellen (JOIN)",
      "domain": "schule/informatik/datenbanken",
      "reduction": "axiomatic",
      "typical_age_min": 14.0,
      "prerequisites": [
        {
          "atom_id": "01K4D9B0000000000000000A02",
          "type": "hard",
          "rationale": "Fremdschlüsselbeziehungen sind Voraussetzung für Verbundabfragen (JOIN)."
        },
        {
          "atom_id": "01K4D9B0000000000000000A03",
          "type": "hard",
          "rationale": "SQL-Grundsyntax ist Voraussetzung für JOIN-Abfragen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q47607",
          "target_label": "Join (SQL)",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 9,
          "track": "I",
          "subject": "informatik",
          "topic_code": "lb1",
          "topic_title": "Relationale Datenbanksysteme",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D9B0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welche Klausel verknüpft in SQL zwei Tabellen über die Übereinstimmung von Primärschlüssel und Fremdschlüssel?",
          "concept": "JOIN ... ON (z. B. INNER JOIN ... ON Schueler.KlasseID = Klasse.KlasseID)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "INNER JOIN ... ON",
              "GROUP BY"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D9B0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das Prinzip eines INNER JOIN und formuliere eine SQL-Abfrage, die den Schülernamen (Tabelle Schueler) zusammen mit dem Namen des Klassenlehrers (Tabelle Klasse über KlassenID verknüpft) abfragt.",
          "concept": "Verknüpft Zeilen beider Tabellen, wenn Verbundbedingung PK = FK erfüllt ist; SELECT Schueler.Nachname, Klasse.Klassenlehrer FROM Schueler JOIN Klasse ON Schueler.KlasseID = Klasse.ID;",
          "sample_solution": "Ein INNER JOIN (Verbund) kombiniert Datensätze aus zwei Tabellen zu einer virtuellen Gesamttabelle, indem er nur diejenigen Zeilen zusammenführt, bei denen der Primärschlüssel der einen Tabelle mit dem Fremdschlüssel der anderen Tabelle übereinstimmt (ON-Bedingung). SQL-Beispiel: SELECT Schueler.Nachname, Klasse.Klassenlehrer FROM Schueler INNER JOIN Klasse ON Schueler.KlasseID = Klasse.ID;"
        }
      ]
    }
  ]
}
